import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createAdminUser } from '../../services/adminManagementServices';
import { Link, useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../core/data/redux/store';
import { Breadcrumb, Card, Button, Form, Input, Select, Checkbox, Typography, message } from 'antd';

const { Title } = Typography;
const { Option } = Select;

const CreateAdmin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isLoading, isError, errorMessage } = useSelector((state: any) => state.adminManagement);
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    dispatch(createAdminUser(values));
    message.success('Admin created successfully');
    navigate('/admin/admin-management/list-admins');
  };

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management">Admin Management</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management/list-admins">List Admins</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create Admin</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Create New Admin</Title>
          {isError && (
            <div style={{ marginBottom: 16 }}>
              <Typography.Text type="danger">{errorMessage}</Typography.Text>
            </div>
          )}
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              role: 'ADMIN',
              is_verified: true,
              is_notification_allowed: true,
            }}
          >
            <Form.Item name="username" label="Username" rules={[{ required: true, message: 'Please enter username' }]}> 
              <Input placeholder="Enter username" />
            </Form.Item>
            <Form.Item name="full_name" label="Full Name" rules={[{ required: true, message: 'Please enter full name' }]}> 
              <Input placeholder="Enter full name" />
            </Form.Item>
            <Form.Item name="email_address" label="Email Address" rules={[{ type: 'email', message: 'Please enter a valid email' }]}> 
              <Input placeholder="Enter email address" />
            </Form.Item>
            <Form.Item name="phone_number" label="Phone Number" rules={[{ required: true, message: 'Please enter phone number' }]}> 
              <Input placeholder="Enter phone number" />
            </Form.Item>
            <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Please enter password' }]}> 
              <Input.Password placeholder="Enter password" />
            </Form.Item>
            <Form.Item name="role" label="Role" rules={[{ required: true, message: 'Please select a role' }]}> 
              <Select>
                <Option value="USER">User</Option>
                <Option value="ADMIN">Admin</Option>
                <Option value="SUPER_ADMIN">Super Admin</Option>
              </Select>
            </Form.Item>
            <Form.Item name="biography" label="Biography">
              <Input.TextArea rows={3} placeholder="Enter biography" />
            </Form.Item>
            <Form.Item name="is_verified" valuePropName="checked">
              <Checkbox>Verified User</Checkbox>
            </Form.Item>
            <Form.Item name="is_notification_allowed" valuePropName="checked">
              <Checkbox>Allow Notifications</Checkbox>
            </Form.Item>
            <Form.Item style={{ textAlign: 'right' }}>
              <Link to="/admin/admin-management/list-admins">
                <Button style={{ marginRight: 8 }}>Cancel</Button>
              </Link>
              <Button type="primary" htmlType="submit" loading={isLoading}>
                Create Admin
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default CreateAdmin; 